import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const ArrowLeft = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.4697 4.46967C11.7626 4.17678 12.2373 4.17678 12.5302 4.46967C12.8231 4.76256 12.8231 5.23732 12.5302 5.53022L6.81049 11.2499H18.9999C19.4142 11.2499 19.7499 11.5857 19.7499 11.9999C19.7499 12.4142 19.4142 12.7499 18.9999 12.7499H6.81049L12.5302 18.4697L12.582 18.5263C12.8223 18.8209 12.8048 19.2556 12.5302 19.5302C12.2556 19.8048 11.8209 19.8223 11.5263 19.582L11.4697 19.5302L4.46967 12.5302C4.17678 12.2373 4.17678 11.7626 4.46967 11.4697L11.4697 4.46967Z"
        fill={color}
      />
    </svg>
  )
}
